import {useMutation, useQueryClient} from "@tanstack/react-query";
import {TRANSACTIONS_QUERY_KEY} from "@/pages/private/Transactions/useTransactions";
import {WALLET_QUERY_KEY} from "@/pages/private/Wallet/useWallet";
import type {TransferPayload} from "./transfer.schema";
import {sendMoneyService, type TransferResponse} from "./transfer.service";

export const useTransfer = () => {
  const queryClient = useQueryClient();
  const mutation = useMutation<TransferResponse, Error, TransferPayload>({
    mutationFn: sendMoneyService,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: WALLET_QUERY_KEY});
      queryClient.invalidateQueries({queryKey: [TRANSACTIONS_QUERY_KEY]});
    },
  });

  return mutation;
};
